import type { Components, Theme } from '@mui/material';

export const MuiTabs: Components<Omit<Theme, 'components'>>['MuiTabs'] = {
  styleOverrides: {
    indicator: () => ({
      backgroundColor: '#26DFD2',
    }),
    root: {
      minHeight: '42px',
      maxHeight: '42px',
      height: '42px',
    },
  },
};
